<template>
  <div id="app">
    <navbar ref="navbar" />
    <div class="content-wrapper" ref="wrapper" :style="{minHeight: viewHeight + 'px', backgroundImage: `url(${contentBgImg})`}">
       <!-- <div class="dot-wrapper">
        <div class="dot" v-for="item in dots" :class="item.cls" :style="item.style"></div>
      </div> -->
       <div class="view-container" ref="view"><router-view /></div>
    </div>
    <toolBar />
    <v-footer :show="!$store.state.route.meta.hideFooter" ref="footer" />
    <!-- 计算器 -->
    <!-- <div class="side-fixed" v-show="$store.state.route.meta.showSidebar">
      <a href="javascript:;" class="figure calc" @click="calcShow=true">
        <img style="margin-left:-6px" src="/static/img/sidebar-home-calc.png">
      </a>
    </div> -->
    <!-- <city :show="cityShow" @dismiss="cityShow=false" /> -->
    <!-- <login :show="$store.state.toLogin" @dismiss="$store.commit('changeLogin', false)" /> -->
    <!-- <calculator :show="calcShow" @dismiss="calcShow=false" /> -->
    <Appointment/>
  </div>
</template>

<script>
  import Navbar from '@/components/navbar/navbar'
  import VFooter from '@/components/footer/footer'
  import Appointment from '@/components/consultant/appointment'
  import Calculator from '@/components/home/calculator-new'
  import ToolBar from '@/components/combo/toolbar'
  import {bindEvent, removeEvent} from '@/util'

  export default {
    name: 'app',
    data () {
      return {
        dots: [],
        scrollWidth: (document.documentElement || document.body).scrollWidth,
        clientHeight: (document.documentElement || document.body).clientHeight,
        viewHeight: 0,
        cityShow: false,
        contentBgImg: ''
      }
    },
    components: {
      Navbar,
      VFooter,
      Calculator,
      ToolBar,
      Appointment
    },
    mounted () {
      this.headHeight = this.$refs.navbar.$el.offsetHeight
      this.footHeight = this.$refs.footer.$el.offsetHeight
      this.windowResize = () => {
        this.clientHeight = (document.documentElement || document.body).clientHeight
        this.scrollWidth = (document.documentElement || document.body).scrollWidth
      }
      this.viewResize = () => {
        this.onResize()
      }
      bindEvent(window, 'resize', this.windowResize)
      bindEvent(this.$refs.view, 'resize', this.viewResize)
      this.routeChange()
    },
    beforeDestroy () {
      removeEvent(window, 'resize', this.windowResize)
      removeEvent(this.$refs.view, 'resize', this.viewResize)
    },
    watch: {
      '$route': 'routeChange',
      scrollWidth: 'onResize',
      clientHeight: 'onResize',
      viewHeight (val) {
        this.dots = []
        if (val > 0) {
          this._refreshDots()
        }
      }
    },
    methods: {
      _refreshDots () {
        let height = this.viewHeight
        let halfWidth = (this.scrollWidth - 1170) / 2
        if (height === 0 || halfWidth === 0) {
          return
        }
        let result = []
        let random = (min, max) => {
          return Math.floor(Math.random() * (max - min + 1) + min)
        }
        let generatorHalfDots = (n, pos) => {
          let s = []
          for (let i = 0; i < n; i++) {
            let bollSize = random(9, 36)
            let l = random(0, parseInt(halfWidth - bollSize))
            let item = {
              cls: `dot-${pos}-${i}`,
              style: {
                position: 'absolute',
                width: bollSize + 'px',
                height: bollSize + 'px',
                left: (pos === 'left' ? l : halfWidth + 1170 + l) + 'px',
                top: random(0, parseInt(height - bollSize)) + 'px'
              }
            }
            s.push(item)
          }
          return s
        }
        result = result.concat(generatorHalfDots(random(3, Math.round(height / 80)), 'left'))
        result = result.concat(generatorHalfDots(random(3, Math.round(height / 80)), 'right'))
        this.dots = result
      },
      _calcViewHeight () {
        let contentHeight = this.$refs.view.offsetHeight
        if (this.$route.meta.hideFooter) {
          this.viewHeight = this.clientHeight
        } else {
          this.viewHeight = Math.max(this.clientHeight - this.footHeight, contentHeight)
        }
      },
      onResize (val) {
        window.clearTimeout(this.__timer)
        this.__timer = setTimeout(() => {
          this._calcViewHeight()
        }, 300)
      },
      routeChange () {
        if (this.$route.meta.requireAuth && !this.$store.state.token) {
          this.$router.replace('/')
        }
        this.contentBgImg = this.$route.meta.bgImg == null ? '/static/img/borrow-bg.png' : this.$route.meta.bgImg
        this.$nextTick(() => {
          this._calcViewHeight()
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import './stylus/mixin'
  @import './stylus/base'
  @import './stylus/form'
  @import './stylus/modal'

  .side-fixed
    position fixed
    top 320px
    right 5px
    width 89px
    z-index 8000
    .figure
      display block
      line-height 1
      text-align center
      text-decoration none
      font-size 0
      color #1a4369
      .fig-media
        display block
        font-size 70px
        text-shadow 0 1px 13px rgba(35, 55, 73, .51)
      .figcaption
        display inline-block
        width 89px
        padding 3px 0
        font-size 14px
        color #fff
        background-color #1a4369
        box-shadow 0 1px 13px 0 rgba(35, 55, 73, .51)
</style>



// WEBPACK FOOTER //
// App.vue?1bdd7fda